module.exports = __webpack_public_path__ + "img/IOT02.d799f408.jpg";